import { render, staticRenderFns } from "./removal-shipment.vue?vue&type=template&id=51477490&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./removal-shipment.vue?vue&type=script&lang=js&"
export * from "./removal-shipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51477490",
  null
  
)

export default component.exports